import axios from 'axios'

export const transactions = {
    state:{
        transactions: [],
        recenttransactions: []
    },
    mutations:{
      Transactions(state, data){
        state.transactions = data.data
      },
      RecentTrans(state, data){
          state.recenttransactions = data.data
      }
    },
    actions:{
        // =================Transactions management =============
        PostTransactions: ({commit}, payload) => {
            return new Promise((resolve, reject)=>{
            axios.post("/transactions", payload)
            .then(({data, status})=>{
                if(status === 201){
                commit()
                resolve(data);
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },

        GetRecentTransactions: ({commit}) => {
            return new Promise((resolve, reject)=>{
              axios.get("/recenttrans")
              .then(({data, status})=>{
                if(status === 200){
                  commit('RecentTrans', data)
                  resolve(data);
                }
              })
              .catch((error)=>{
                reject(error);
              });
            })
          },
    }
}